import React from "react";
import "./leftinfopanel.css";
import { Link } from "react-router-dom";

const LeftInfoPanel = () => {
  return (
    <div className="left-panel">
      <h2 className="title">
        Create Your Free <br />
        Digital Business Card in 5 Minutes
      </h2>

      <p className="description">
        Save trees while building meaningful business connections.
        With NeooCard, you can share your digital identity instantly,
        expand your network, and turn every meeting into a business opportunity.
      </p>

      <p className="description">
        As part of our <strong>Corporate social responsibility</strong>, we help your
        business grow while contributing to a greener future—driven by our{" "}
        <strong>Vision 2030 to create 1 Million digital business connections.</strong>
      </p>

      <div className="plan-box">
        <h3>Free Plan</h3>
        <p>No monthly fees—ever. Get started with our free version and explore essential features and styles.</p>

        <div className="price-box">AED 0</div>

        <div className="features">
          <h4>Features & Benefits</h4>
          <ul className="mt-2">
            <li>🌱 Your Own Eco-Friendly Digital Business Card</li>
            <li>Be part of Vision 30 – 1 million digital connections</li>
            <li>Free Membership in the Neoo Search Business Community</li>
            <li>Share via Link with Card Preview Image</li>
            <li>Unique QR Code for Instant Access</li>
            <li>Personalized Profile Link</li>
            <li>Easy Contact Details Management</li>
            <li>Social Media Links Integration</li>
            <li>Analytics & Insights</li>
            <li>Update Your Information Anytime</li>
          </ul>
        </div>

        <Link to="/about-neoocard" className="about-link">
          About NeooCard
        </Link>
      </div>
    </div>
  );
};

export default LeftInfoPanel;